import _ from 'lodash';

const WHITE = '#FFFFFF';
const BLUE = '#2E83D9';
const LIGHTGREY = '#EAEAF2';
const TEXT_GREY = '#202028';

const commonPalette = {
  backgroundColorsNew: {
    buttonBlue: BLUE,
    buttonBlueHover: '#3990E8',
    buttonDarkBlue: '#1D337B',
    buttonLightGray: '#3F4159',
    // buttonLightGray2: '#363850',
  },
  iconColorNew: {
    active: BLUE,
    appIcon: '#3D3F53',
  },
  sizes: {
    blockBorderRadius: '4px',
    blockPadding: '18px 28px 16px 24px',
    squareAvatarRadius: '8px',
  },
  textColorNew: {
    buttonPrimary: WHITE,
    error: '#D92E4D',
    fileInfo: '#8083A0',
    link: BLUE,
    placeholderColor: '#8083A0',
    white: WHITE,
  },
};

const darkPalette = {
  backgroundColorsNew: {
    a100: 'rgba(255, 255, 255, 0.04)',
    a200: 'rgba(255, 255, 255, 0.08)',
    a300: 'rgba(255, 255, 255, 0.16)',
    app: '#1A1B2B',
    buttonGray: '#2D2E41',
    cardHover: '#343637',
    dialog: '#2D2E41',
    lightGray: '#8083A0',
    navItem: '#2A2C41',
    primary: '#222335',
    secondary: '#2A2B3D',
    textField: '#2C2D42',
    topicsItem: '#2D2E41',
    uploader: '#3F4159',
  },
  borderColorsNew: {
    button: '#1A1B2B',
    frame: 'rgba(255, 255, 255, 0.2)',
    primary: 'transparent',
  },
  chat: {
    answerMessageBg: '#2A2C41',
    authorColor: '#83BAF2',
    dateSeparatorBg: '#2A2C41',
    dateSeparatorText: 'white',
    deleteButtonColor: '#EB5545',
    folderTabColor: '#8083A0',
    newMessageBg: '#8083A0',
    voiceWaveColor: WHITE,
  },
  iconColorNew: {
    primary: '#8083A0',
    secondary: WHITE,
  },
  nauSearch: {
    recentBg: '#242535',
  },
  nauSphere: {
    buttonBg: '#8083A0',
    buttonColor: WHITE,
    commentBorder: '#2A2C41',
  },
  postCreate: {
    buttonTopicAddBg: BLUE,
    buttonTopicBg: '#2D2E41',
  },
  primary: {
    contrast: 'white',
    contrastText: '#fff',
    dark: '#205b97',
    light: '#579be0',
    main: BLUE,
  },
  profile: {
    bannerButtonBackground: '#363850',
    bannerButtonText: 'white',
    editButtonBackground: '#363850',
    editButtonText: 'white',
    headerBottom: '#242535',
    headerTop: '#2D2E41',
    inputLabel: '#8083A0',
    profileInputBackground: '#1A1B2B',
  },
  savedSearch: {
    savedSearchCardBg: '#2A2C41',
  },
  textColorNew: {
    buttonSecondary: WHITE,
    primary: WHITE,
    secondary: '#8083A0',
  },
};

const lightPalette = {
  backgroundColorsNew: {
    a100: 'rgba(0, 0, 0, 0.06)',
    a200: 'rgba(0, 0, 0, 0.12)',
    a300: 'rgba(0, 0, 0, 0.24)',
    app: '#F2F2F2',
    buttonGray: '#D9DBDE',
    cardHover: '#f9f9f9',
    dialog: WHITE,
    lightGray: '#8C8D9A',
    navItem: '#EAEAF2',
    primary: WHITE,
    secondary: WHITE,
    textField: WHITE,
    topicsItem: LIGHTGREY,
    uploader: WHITE,
  },
  borderColorsNew: {
    button: TEXT_GREY,
    frame: 'rgba(0, 0, 0, 0.2)',
    primary: '#DBDEE9',
  },
  chat: {
    answerMessageBg: '#EAEAF2',
    authorColor: '#2E83D9',
    dateSeparatorBg: '#F5F5F9',
    dateSeparatorText: '#8083A0',
    deleteButtonColor: '#EB5545',
    folderTabColor: '#8083A0',
    newMessageBg: '#8C8D9A',
    voiceWaveColor: '#8083A0',
  },
  iconColorNew: {
    primary: '#8C8D9A',
    secondary: TEXT_GREY,
  },
  nauSearch: {
    recentBg: WHITE,
  },
  nauSphere: {
    buttonBg: '#8083A0',
    buttonColor: WHITE,
    commentBorder: '#EAEAF2',
  },
  postCreate: {
    buttonTopicAdd: BLUE,
    buttonTopicBg: LIGHTGREY,
  },
  primary: {
    contrast: 'black',
    contrastText: TEXT_GREY,
    dark: '#205b97',
    light: '#579be0',
    main: BLUE,
  },
  profile: {
    bannerButtonBackground: '#363850',
    bannerButtonText: 'white',
    editButtonBackground: LIGHTGREY,
    editButtonText: 'black',
    headerBottom: WHITE,
    headerTop: LIGHTGREY,
    profileInputBackground: LIGHTGREY,
  },
  savedSearch: {
    savedSearchCardBg: '#F5F5F9',
  },
  textColorNew: {
    buttonSecondary: TEXT_GREY,
    primary: TEXT_GREY,
    secondary: '#8C8D9A',
  },
};
const newThemePalette = {
  dark: _.merge(darkPalette, commonPalette),
  light: _.merge(lightPalette, commonPalette),
};

export default newThemePalette;
